module.exports = __webpack_public_path__ + "static/img/officialSiteBottom.dbcd62f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/index/img/officialSiteBottom.jpg
// module id = 89wZ
// module chunks = 1